import { downloadImage } from "../services";

function DownloadModal({ imgSrc, setShowModal }) {
  return (
    <div className="shadow relative bg-white p-12 pb-0 md:pb-0 m-6 md:px-14 rounded md:pt-11 flex flex-col items-center">
      <div className="absolute top-3 right-4">
        <svg
          onClick={() => setShowModal(false)}
          className=" w-6 h-6 cursor-pointer"
          fill="currentColor"
          viewBox="0 0 20 20"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
            clipRule="evenodd"
          ></path>
        </svg>
      </div>
      <h5 className="font-semibold text-lg mb-7">Download image</h5>
      <img className="h-44 w-[282px]" src={`/${imgSrc}.png`} alt={imgSrc} />
      <h5 className="font-semibold my-[18px] text-lg ">{imgSrc}</h5>
      <p className="font-regular text-lg">3 free downloads remaining</p>
      <div className="flex items-center mb-6">
        <img
          className="mx-1 cursor-pointer"
          onClick={() => downloadImage(`/${imgSrc}.png`)}
          src="download.svg"
          alt="download"
        />
        <img className="mx-1 cursor-pointer" src="share.svg" alt="share" />
      </div>
    </div>
  );
}

export default DownloadModal;
